import Cookies from 'js-cookie';
import { client } from '.';
import { logoutFromUI } from '../../routes/ProfilePages/ProfileContent/utils';
import { REFRESH_TOKENS_MUTATION } from '../apis/auth/mutations';
import dayjs from 'dayjs';
import { ERROR_MESSAGE_AUTH } from '../responseErrorMessages';
import {
  addRefreshTokenAttempt,
  clearRefreshTokenAttempts,
  hasExceededRefreshTokenAttempts,
} from './refreshTokensUtils';
export const getAccessToken = (): string =>
  localStorage.getItem('accessToken') || '';

export const AUTH_TOKEN_REFRESHED_EVENT = 'authTokensRefreshed';

interface TokensResponse {
  accessToken: string;
  refreshToken?: string;
}

const handleRefreshTokensSuccess = ({
  tokens,
  userId,
}: {
  tokens: TokensResponse;
  userId: string;
}) => {
  const isDevEnv = process.env.NODE_ENV === 'development';

  clearRefreshTokenAttempts();

  localStorage.setItem('accessToken', tokens.accessToken);
  localStorage.setItem('accessTokenCreatedAt', dayjs().toISOString());

  if (isDevEnv && tokens.refreshToken) {
    Cookies.set('refreshToken', tokens.refreshToken, {
      expires: 14,
      secure: false,
      sameSite: 'lax',
    });
  }

  Cookies.set('id', userId, {
    expires: 14,
  });

  window.dispatchEvent(new Event(AUTH_TOKEN_REFRESHED_EVENT));
};

export const refreshAuthTokens = async () => {
  const userId = String(Cookies.get('id'));

  try {
    const isDevEnv = process.env.NODE_ENV === 'development';
    const refreshTokenForWebDevEnv = isDevEnv
      ? Cookies.get('refreshToken')
      : undefined;

    const refreshTokensResponse = await client.mutate({
      mutation: REFRESH_TOKENS_MUTATION,
      variables: isDevEnv ? { refreshTokenForWebDevEnv } : {},
    });

    const tokens = {
      accessToken: refreshTokensResponse?.data?.refreshTokens?.accessToken,
      refreshToken:
        refreshTokensResponse?.data?.refreshTokens?.refreshTokenForWebDevEnv,
    };

    if (!tokens.accessToken) {
      throw new Error('Failed to refresh tokens');
    }

    handleRefreshTokensSuccess({ tokens, userId });

    return tokens;
  } catch (err: any) {
    const hasUserIdStored =
      Boolean(userId) && userId !== 'undefined' && userId !== 'null';
    console.error('Error during refreshAuthTokens:', err);

    const errorMessage = err?.graphQLErrors?.[0]?.message || err.message;
    addRefreshTokenAttempt(errorMessage);

    const shouldForceLogout =
      errorMessage === ERROR_MESSAGE_AUTH.TOKEN_EXPIRED_OR_INVALID ||
      hasExceededRefreshTokenAttempts();

    if (hasUserIdStored && shouldForceLogout) {
      logoutFromUI();
    }

    throw err;
  }
};
